import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import queryString from 'query-string';
import { getRedirect } from '../services/redirect.service';
import { useHistory } from 'react-router';

const styles = theme => ({});

export const Redirect = withStyles(styles)(props => {
  const [query] = useState(queryString.parse(props.history.location.search));
  const [dataLoading, setDataLoading] = useState(false);
  const [error, setError] = useState();

  const history = useHistory();

  const { classes } = props;

  const handleFetchData = async () => {
    try {
      setDataLoading(true);
      setError(undefined);
      console.log({
        query
      });

      const response = await getRedirect(query);

      window.location = response;
    } catch (error) {
      //
      console.log(error);
      setError(error);
    }
    setDataLoading(false);
  };

  useEffect(() => {
    // check for data to post
    handleFetchData();
  }, []);

  return (
    <div className={classnames('flex-1', 'row-center-center', classes.gridContainer)}>
      <div
        style={{
          fontSize: 24,
          fontWeight: 'bold',
        }}
      >
        {dataLoading ? 'Loading... Please Wait' : error?.statusText}
      </div>
    </div>
  );
});

Redirect.propTypes = {};

Redirect.defaultProps = {};
